import React from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'


class CV extends React.Component {

  constructor(props) {
    super(props);

    let username = false;
    let highlight = false;
    let pathname = this.props.pathname.replace("/@", "");
    if(pathname !== "" && pathname !== "/") {
      username = pathname.split("/").shift();
      highlight = pathname.split("/").pop();
      if(username === highlight) highlight = "";
    } else {
      this.props.push("/");
    }

    this.state = {username, highlight};
  }

  componentWillMount() {
    const pageAccessedByReload = (
      (window.performance.navigation && window.performance.navigation.type === 1) || window.performance
      .getEntriesByType('navigation')
      .map((nav) => nav.type)
      .includes('reload')
    );
    if(pageAccessedByReload) {
      this.props.clearStateBlock("cv_"+this.state.username);
      this.props.clearStateBlock("work_"+this.state.username);
      this.props.clearStateBlock("highlight_"+this.state.username);
    }
    if(this.state.username) {
      this.props.fetchDataIfReady(config.api_token, "cv_"+this.state.username, "GET", config.api_url+"/cv?username="+this.state.username);
      this.props.fetchDataIfReady(config.api_token, "work_"+this.state.username, "GET", config.api_url+"/work?username="+this.state.username);
      this.props.fetchDataIfReady(config.api_token, "highlight_"+this.state.username, "GET", config.api_url+"/highlight?username="+this.state.username);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.state.username) {
      this.props.fetchDataIfUndefined(config.api_token, "cv_"+this.state.username, "GET", config.api_url+"/cv?username="+this.state.username);
      this.props.fetchDataIfUndefined(config.api_token, "work_"+this.state.username, "GET", config.api_url+"/work?username="+this.state.username);
      this.props.fetchDataIfUndefined(config.api_token, "highlight_"+this.state.username, "GET", config.api_url+"/highlight?username="+this.state.username);
    }
  }

  render() {
    let cv = this.props.apiData["cv_"+this.state.username], work = this.props.apiData["work_"+this.state.username], highlight = this.props.apiData["highlight_"+this.state.username];
    if(cv !== undefined && !cv.isFetching && cv.data[0] !== undefined) {
      let cv_data = cv.data[0];
      let contact = {};
      let links = "";
      if(cv_data.contact_json !== "") contact = JSON.parse(cv_data.contact_json);
      if(cv_data.links_json !== "") links = cv_data.links_json;
      let work_defined = work !== undefined && !work.isFetching && work.data[0] !== undefined;
      let highlight_defined = highlight !== undefined && !highlight.isFetching && highlight.data[0] !== undefined;

      // 1-op-1 van Notes.js
      // dit soort loops/functies/cleaners/decorators ook naar Skelet denk ik.
      let mapped_text = null; // mss een andere naam dan "wrapped", en in de mapper "item" aanpassen. (mss "mapped_description"?)
      if(cv_data.biography !== "") {
        mapped_text = cv_data.biography.split('\n').map(function(item, key) {
          // item = item.replace(new RegExp(" ", 'g'), String.fromCharCode(160)); // this assures proper rendering of offset spaces.
          let new_item = "", first_nonspace = false;
          for (let i = 0; i < item.length; i++) {
            if(item.charAt(i) === " " && !first_nonspace) {
              new_item = new_item + String.fromCharCode(160);
            } else {
              first_nonspace = true;
              new_item = new_item + item.charAt(i);
            }
          }
          item = new_item;
          return <span key={key}>{item}<br/></span>;
        });
      }

      let mapped_links = null;
      if(links.length > 0) {
        mapped_links = links.split(';;').map(function(lnk_text, key) {
          let lnk = JSON.parse(lnk_text);
          let lnk_url = lnk.text;
          if(!lnk_url.startsWith("https://") && !lnk_url.startsWith("http://")) {
            lnk_url = "https://"+lnk_url;
          }
          let lnk_txt = lnk_url;
          lnk_txt = lnk_txt.replace("https://", "");
          lnk_txt = lnk_txt.replace("http://", "");
          return <a key={key} className="btn btn-offset" href={lnk_url} target="_blank" rel="noopener noreferrer nofollow">{lnk_txt}</a>;
        });
      }

      let work_card = null;
      if(work_defined) {
        work_card = work.data.map(function(exp, key) {
          let company_url = "";
          if(exp.company_url) {
            company_url = exp.company_url;
            if(!company_url.startsWith("https://") && !company_url.startsWith("http://")) {
              company_url = "https://"+company_url;
            }
          }

          let both_months = false;
          let start_month_only = false;
          let end_month_only = false;
          const start_date = new Date(exp.start_month);
          const end_date = new Date(exp.end_month);
          let start_month = start_date.getDate()+" "+start_date.toLocaleString('default', { month: 'long' })+" "+start_date.getFullYear();
          let end_month = end_date.getDate()+" "+end_date.toLocaleString('default', { month: 'long' })+" "+end_date.getFullYear();
          if(exp.start_month.substring(0,4) !== "0000" && exp.end_month.substring(0,4) !== "0000") both_months = true;
          if(exp.start_month.substring(0,4) !== "0000" && exp.end_month.substring(0,4) === "0000") start_month_only = true;
          if(exp.start_month.substring(0,4) === "0000" && exp.end_month.substring(0,4) !== "0000") end_month_only = true;

          let description = null;
          if(exp.description) {
            description = exp.description.split('\n').map(function(item, key) {
              // item = item.replace(new RegExp(" ", 'g'), String.fromCharCode(160)); // this assures proper rendering of offset spaces.
              let new_item = "", first_nonspace = false;
              for (let i = 0; i < item.length; i++) {
                if(item.charAt(i) === " " && !first_nonspace) {
                  new_item = new_item + String.fromCharCode(160);
                } else {
                  first_nonspace = true;
                  new_item = new_item + item.charAt(i);
                }
              }
              item = new_item;
              return <span key={key}>{item}<br/></span>;
            });
          }

          let status = null;
          if(exp.status !== 0) {
            let status_text = null;
            switch (exp.status) {
              case 1:
              status_text = <span><span role="img" aria-label="woman office worker">👩‍💼</span> 9-to-5</span>;
              break;
              case 2:
              status_text = <span><span role="img" aria-label="smirk">😏</span> Freelance</span>;
              break;
              case 3:
              status_text = <span><span role="img" aria-label="lightbulb">💡</span> Ideation</span>;
              break;
              case 4:
              status_text = <span><span role="img" aria-label="hammer and wrench">🛠️</span> Building</span>;
              break;
              case 5:
              status_text = <span><span role="img" aria-label="rocket">🚀</span> Launched</span>;
              break;
              case 6:
              status_text = <span><span role="img" aria-label="plant seedling">🌱</span> Growing</span>;
              break;
              case 7:
              status_text = <span><span role="img" aria-label="money bag">💰</span> Revenue</span>;
              break;
              case 8:
              status_text = <span><span role="img" aria-label="robot">🤖</span> Automated</span>;
              break;
              case 9:
              status_text = <span><span role="img" aria-label="party popper">🎉</span> Acquired</span>;
              break;
              case 10:
              status_text = <span><span role="img" aria-label="cross mark">❌</span> Quit</span>;
              break;
              default:
              status_text = <span>Undefined status</span>;
              break;
            }
            status = <span className="btn" style={{position:"absolute", fontWeight:"400", fontSize:".6em", right:"0"}}>{status_text}</span>;
          }

          return <div key={"div"+key} style={{marginBottom:"3em"}}>
                    <h2 style={{margin:"0", position:"relative"}}>{exp.role}{status}</h2>
                    {exp.company && exp.company_url && <a href={company_url} target="_blank" rel="noopener noreferrer nofollow">{exp.company}</a>}
                    {exp.company && !exp.company_url && <span >{exp.company}</span>}
                    {both_months && <p style={{margin:"0", opacity:".7"}}>{start_month} - {end_month}</p>}
                    {start_month_only && <p style={{margin:"0", opacity:".7"}}>{start_month} - present</p>}
                    {end_month_only && <p style={{margin:"0", opacity:".7"}}>No start date - {end_month}</p>}
                    {exp.location && <p style={{margin:"0", opacity:".7"}}>{exp.location}</p>}
                    {exp.description && <p style={{margin:"1em 0"}}>{description}</p>}
                  </div>;
        })
      }


      let highlighted_work_card = null;
      let hl = undefined;
      if(highlight_defined) {
        hl = highlight.data.filter(function(highlight) {
          return this.state.highlight === highlight.name;
        }.bind(this))[0];
      }
      if(work_defined && hl) {
        // a lot of duplicate code, copied directly from work data
        highlighted_work_card = work.data.map(function(exp, key) {
          let ids_array = hl.work_ids.split(";;"); // this line, and..
          if(!ids_array.includes(""+exp.id)) return null; // this line, are the only non-copied parts (and wrapping div styling)
          let company_url = "";
          if(exp.company_url) {
            company_url = exp.company_url;
            if(!company_url.startsWith("https://") && !company_url.startsWith("http://")) {
              company_url = "https://"+company_url;
            }
          }

          let both_months = false;
          let start_month_only = false;
          let end_month_only = false;
          const start_date = new Date(exp.start_month);
          const end_date = new Date(exp.end_month);
          let start_month = start_date.getDate()+" "+start_date.toLocaleString('default', { month: 'long' })+" "+start_date.getFullYear();
          let end_month = end_date.getDate()+" "+end_date.toLocaleString('default', { month: 'long' })+" "+end_date.getFullYear();
          if(exp.start_month.substring(0,4) !== "0000" && exp.end_month.substring(0,4) !== "0000") both_months = true;
          if(exp.start_month.substring(0,4) !== "0000" && exp.end_month.substring(0,4) === "0000") start_month_only = true;
          if(exp.start_month.substring(0,4) === "0000" && exp.end_month.substring(0,4) !== "0000") end_month_only = true;

          let description = null;
          if(exp.description) {
            description = exp.description.split('\n').map(function(item, key) {
              // item = item.replace(new RegExp(" ", 'g'), String.fromCharCode(160)); // this assures proper rendering of offset spaces.
              let new_item = "", first_nonspace = false;
              for (let i = 0; i < item.length; i++) {
                if(item.charAt(i) === " " && !first_nonspace) {
                  new_item = new_item + String.fromCharCode(160);
                } else {
                  first_nonspace = true;
                  new_item = new_item + item.charAt(i);
                }
              }
              item = new_item;
              return <span key={key}>{item}<br/></span>;
            });
          }

          let status = null;
          if(exp.status !== 0) {
            let status_text = null;
            switch (exp.status) {
              case 1:
              status_text = <span><span role="img" aria-label="woman office worker">👩‍💼</span> 9-to-5</span>;
              break;
              case 2:
              status_text = <span><span role="img" aria-label="smirk">😏</span> Freelance</span>;
              break;
              case 3:
              status_text = <span><span role="img" aria-label="lightbulb">💡</span> Ideation</span>;
              break;
              case 4:
              status_text = <span><span role="img" aria-label="hammer and wrench">🛠️</span> Building</span>;
              break;
              case 5:
              status_text = <span><span role="img" aria-label="rocket">🚀</span> Launched</span>;
              break;
              case 6:
              status_text = <span><span role="img" aria-label="plant seedling">🌱</span> Growing</span>;
              break;
              case 7:
              status_text = <span><span role="img" aria-label="money bag">💰</span> Revenue</span>;
              break;
              case 8:
              status_text = <span><span role="img" aria-label="robot">🤖</span> Automated</span>;
              break;
              case 9:
              status_text = <span><span role="img" aria-label="party popper">🎉</span> Acquired</span>;
              break;
              case 10:
              status_text = <span><span role="img" aria-label="cross mark">❌</span> Quit</span>;
              break;
              default:
              status_text = <span>Undefined status</span>;
              break;
            }
            status = <span className="btn" style={{position:"absolute", fontWeight:"400", fontSize:".6em", right:"0"}}>{status_text}</span>;
          }

          return <div key={"div"+key} style={{marginBottom:"3em", padding:"2em", background:"#fffff1", border:"1px solid beige"}}>
                    <h2 style={{margin:"0", position:"relative"}}>{exp.role}{status}</h2>
                    {exp.company && exp.company_url && <a href={company_url} target="_blank" rel="noopener noreferrer nofollow">{exp.company}</a>}
                    {exp.company && !exp.company_url && <span >{exp.company}</span>}
                    {both_months && <p style={{margin:"0", opacity:".7"}}>{start_month} - {end_month}</p>}
                    {start_month_only && <p style={{margin:"0", opacity:".7"}}>{start_month} - present</p>}
                    {end_month_only && <p style={{margin:"0", opacity:".7"}}>No start date - {end_month}</p>}
                    {exp.location && <p style={{margin:"0", opacity:".7"}}>{exp.location}</p>}
                    {exp.description && <p style={{margin:"1em 0"}}>{description}</p>}
                  </div>;
        })
      }

      return (
        <div style={{background:"#fff"}}>

            <div className="wrap">
              <div style={{background: (cv_data.accent_background ? "#"+cv_data.accent_background : "#000"), color: (cv_data.accent_color ? "#"+cv_data.accent_color : "#fff"), padding:"9px", borderRadius:"0 0 8px 8px"}}>
                <div className="col-2">
                  <h1 style={{marginBottom:"0"}}>{cv_data.firstname+" "+cv_data.lastname}</h1>
                  <p style={{marginTop:"0"}}>@{cv_data.username}</p>
                </div>
                <div className="col-2">
                  {(contact.telephone || contact.email) && <p style={{marginBottom:"1em", textAlign:"right"}}>{contact.telephone}<br/>{contact.email}</p>}
                  {(contact.street || contact.postal || contact.country) && <p style={{marginTop:"0", textAlign:"right"}}>{contact.street}<br/>{contact.postal}<br/>{contact.country}</p>}
                </div>
              </div>
              {links && <div style={{marginTop:"5px"}}>{mapped_links}</div>}
            </div>

            <div className="full">
              <div className="wrap">

                {cv_data.biography && <div className="col-4">
                  <p>About {cv_data.firstname}</p>
                </div>}
                {cv_data.biography && <div className="col-3-4">
                  <p>{mapped_text}</p>
                </div>}

                {work_defined && highlight_defined && hl && <div className="col-4">
                  <p style={{marginTop:"0"}}>Highlighted Work Experience</p>
                </div>}
                {work_defined && highlight_defined && hl && <div className="col-3-4">
                  {highlighted_work_card}
                </div>}

                {work_defined && <div className="col-4">
                  <p style={{marginTop:"0"}}>Work Experience</p>
                </div>}
                {work_defined && <div className="col-3-4">
                  {work_card}
                </div>}

                  {/*<div style={{marginBottom:"3em"}}>
                    <h2 style={{margin:"0"}}>Software Developer</h2>
                    <a href="#" target="_blank">Polymedia</a>
                    <p style={{margin:"0", opacity:".7"}}>mei 2023 - heden · 1 jr 1 mnd</p>
                    <p style={{margin:"0", opacity:".7"}}>Leerdam</p>
                    <p style={{margin:"1em 0"}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam sem odio, fringilla eu tortor eu, venenatis imperdiet ante. Aenean eros quam, dapibus quis velit at, faucibus consectetur urna. Integer vitae neque ante. Quisque leo lacus, molestie et ex nec, suscipit dignissim lectus. Fusce ultrices turpis maximus lorem auctor rutrum. Nulla placerat rutrum quam, in finibus neque. Nam tristique placerat elit et maximus. Aenean id velit odio. Praesent vulputate finibus quam sed rutrum. Suspendisse potenti. Quisque laoreet dolor vel ligula faucibus, id accumsan nisi lacinia. Aenean quam sapien, sollicitudin quis iaculis a, luctus convallis libero.</p>
                    <ul style={{margin:"1em 0"}}>
                      <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                      <li>Nam sem odio, fringilla eu tortor eu, venenatis imperdiet ante.</li>
                      <li>Aenean eros quam, dapibus quis velit at, faucibus consectetur urna.</li>
                    </ul>
                    <div style={{marginTop:"1em"}}><span className="contact-label">Node.js</span><span className="contact-label">JavaScript</span><span className="contact-label">MySQL</span></div>
                  </div>*/}

                {/*<div className="col-4">
                  <p style={{marginTop:"0"}}>Opleidingen</p>
                </div>
                <div className="col-3-4">

                  <div style={{marginBottom:"3em"}}>
                    <h2 style={{margin:"0"}}>HBO Informatica</h2>
                    <p style={{margin:"0"}}>Hogeschool van Utrecht</p>
                    <p style={{margin:"0", opacity:".7"}}>mei 2023 - mei 2024</p>
                    <p style={{margin:"0", opacity:".7"}}>Bachelor of Science</p>
                    <p style={{margin:"1em 0"}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam sem odio, fringilla eu tortor eu, venenatis imperdiet ante. Aenean eros quam, dapibus quis velit at, faucibus consectetur urna. Integer vitae neque ante. Quisque leo lacus, molestie et ex nec, suscipit dignissim lectus. Fusce ultrices turpis maximus lorem auctor rutrum. Nulla placerat rutrum quam, in finibus neque. Nam tristique placerat elit et maximus. Aenean id velit odio. Praesent vulputate finibus quam sed rutrum. Suspendisse potenti. Quisque laoreet dolor vel ligula faucibus, id accumsan nisi lacinia. Aenean quam sapien, sollicitudin quis iaculis a, luctus convallis libero.</p>
                    <ul style={{margin:"1em 0"}}>
                      <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                      <li>Nam sem odio, fringilla eu tortor eu, venenatis imperdiet ante.</li>
                      <li>Aenean eros quam, dapibus quis velit at, faucibus consectetur urna.</li>
                    </ul>
                  </div>

                </div>

                <div className="col-4">
                  <p style={{marginTop:"0"}}>Vaardigheden</p>
                </div>
                <div className="col-3-4">

                  <div className="col-2"><span className="contact-label">Node.js</span></div><div className="col-2">Medior</div>
                  <div className="col-2"><span className="contact-label">JavaScript</span></div><div className="col-2">Senior</div>
                  <div className="col-2"><span className="contact-label">MySQL</span></div><div className="col-2">Senior</div>

                </div>*/}

              </div>
            </div>

            <div className="full">
              <div className="wrap" style={{textAlign:"center"}}>
                <a href="https://curvit.polymedia.nl" className="btn btn-e" target="_blank" rel="noopener noreferrer">Create your own CV with Curvit!</a>
              </div>
            </div>

        </div>
      );
    } else {
      return null;
    }
  }

}


function mapStateToProps(state) {
  return {
    apiData: state.apiData,
    pathname: state.router.location.pathname,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CV)



// WEBPACK FOOTER //
// ./src/containers/CV.js